import {POPUP_SETTINGS} from '@/models/POPUP_SETTINGS';

function getContentFormValue() {
	return POPUP_SETTINGS.CONTENT.SECTIONS[0].CONTENT_FORM.VALUE;
}

export const NODE_EDIT_BAR_OPTIONS = {
	// DESIGN_SETTINGS: {VALUE: 'DESIGN_SETTINGS', TYPE: 'DESIGN_SETTINGS', ICON: 'fas fa-pencil-ruler', ACTION: 'DESIGN_SETTINGS'},
	// CONTENT_SETTINGS: {VALUE: POPUP_SETTINGS.CONTENT.SECTIONS[0].CONTENT_FORM.VALUE, TYPE: POPUP_SETTINGS.CONTENT.SECTIONS[0].CONTENT_FORM.VALUE, ICON: 'fas fa-align-left', ACTION: POPUP_SETTINGS.CONTENT.SECTIONS[0].CONTENT_FORM.VALUE},
	DESIGN: {VALUE: 'DESIGN', TYPE: 'DESIGN', ICON: 'fas fa-pencil-ruler', ACTION: null},
	CONTENT: {VALUE: 'CONTENT', TYPE: 'CONTENT', ICON: 'fas fa-align-left', ACTION: null},
	LINK: {VALUE: 'LINK', get TYPE() { return getContentFormValue(); }, ICON: 'fas fa-link', ACTION: null},
	VISIBILITY: {VALUE: 'VISIBILITY', TYPE: null, ICON: 'fas fa-low-vision', ACTION: null},
	NAVIGATION: {VALUE: 'NAVIGATION', get TYPE() { return getContentFormValue(); }, ICON: 'fas fa-compass', ACTION: null},
	CLONE: {VALUE: 'CLONE', TYPE: null, ICON: 'fas fa-clone', ACTION: 'CLONE'},
	DELETE: {VALUE: 'DELETE', TYPE: null, ICON: 'fas fa-trash', ACTION: 'DELETE'},
	LOCKED: {VALUE: 'LOCKED', TYPE: null, ICON: 'fas fa-lock-open', ICON_CLOSED: 'fas fa-lock', ACTION: 'LOCKED'},
};
